import { render, staticRenderFns } from "./SendBill.vue?vue&type=template&id=5f839b5e"
import script from "./SendBill.vue?vue&type=script&lang=js"
export * from "./SendBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports